export default __webpack_public_path__ + "static/media/rusgot-screenshot-01.eb4790b0.png";